import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EdpToastContainerComponent } from "./edp-toast-container/edp-toast-container.component";
import { EdpToastItemComponent } from "./edp-toast-item/edp-toast-item.component";

@NgModule({
    imports: [CommonModule],
    declarations: [
        EdpToastContainerComponent,
        EdpToastItemComponent
    ],
    entryComponents: [EdpToastContainerComponent, EdpToastItemComponent]
})
export class EdpToasterModule {}
